import React from 'react';
import { clsx } from 'clsx';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  showCount?: boolean;
}

export function Textarea({
  label,
  error,
  helperText,
  showCount,
  maxLength,
  className,
  id,
  value,
  ...props
}: TextareaProps) {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  const currentLength = typeof value === 'string' ? value.length : 0;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-200"
        >
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        value={value}
        maxLength={maxLength}
        className={clsx(
          'block w-full rounded-md border px-3 py-2 text-sm shadow-sm placeholder-gray-400 focus:outline-none focus:ring-1 resize-y min-h-[80px] bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-500',
          error
            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700',
          className
        )}
        {...props}
      />
      <div className="flex justify-between mt-1">
        <div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          {helperText && !error && (
            <p className="text-sm text-gray-500 dark:text-gray-400">{helperText}</p>
          )}
        </div>
        {showCount && maxLength && (
          <p className="text-sm text-gray-400 dark:text-gray-500">
            {currentLength}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
}
